import API from './api';

const InquiryService = {
  // Get all inquiries
  getAllInquiries: async (filters = {}) => {
    try {
      let url = '/inquiries';
      const params = new URLSearchParams();
      
      if (filters.status) params.append('status', filters.status);
      if (filters.search) params.append('search', filters.search);
      if (filters.follow_up_today) params.append('follow_up_today', 'true');
      
      if (params.toString()) {
        url += '?' + params.toString();
      }
      
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get single inquiry
  getInquiryById: async (id) => {
    try {
      const response = await API.get(`/inquiries/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new inquiry
  createInquiry: async (inquiryData) => {
    try {
      const response = await API.post('/inquiries', inquiryData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update inquiry
  updateInquiry: async (id, inquiryData) => {
    try {
      const response = await API.put(`/inquiries/${id}`, inquiryData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete inquiry
  deleteInquiry: async (id) => {
    try {
      const response = await API.delete(`/inquiries/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Convert inquiry to student
  convertToStudent: async (id) => {
    try {
      const response = await API.get(`/inquiries/${id}/convert`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default InquiryService;